<template>
  <div>
    <slot />
  </div>
</template>
<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: black;
  // タッチ端末向けのキオスク化。 ブラウザ側で抑止できる範囲を塞ぐ:
  //   - overscroll-behavior: Android の引っ張って更新 (pull-to-refresh) を無効化
  //   - user-select / touch-callout: 長押しでの文字選択・コピーメニューを抑止
  // ※ ピンチズーム等のジェスチャ抑止 (touch-action: none) は LogOverlay 等の
  //   スクロールを潰さないよう、 配信画面の .wrapper 側で限定的に指定する。
  // ※ ホームボタン/システムバー/ステータスバーは OS 管轄のため CSS では塞げない。
  //   端末側のキオスクモード (画面固定等) で対応する。
  overscroll-behavior: none;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
}

// 機能上スクロールが必要な箇所 (例: LogOverlay) を除き、 スクロールバーは
// 視覚的に隠す。 overflow: hidden の領域でも端末によっては薄く出るため明示。
::-webkit-scrollbar {
  display: none;
}
</style>
